'use client';

import React from 'react';

import { BookingStep, useCartProvider } from '@cineamo/composables/src/providers/cartProvider';

import { useRouter } from '@/i18n/routing';

import BackButton from './BackButton';

/** The step the header's arrow goes back to; from seat picking (or a failed payment) it leaves the page. */
const PREVIOUS_STEP: Partial<Record<BookingStep, BookingStep>> = {
    '02_payment': '01.5_cart',
    '01.5_cart': '01_seat_picking'
};

/**
 * The booking header's back arrow on small screens: one checkout step back, like an app, so the page needs no
 * "Zurück zur …" link of its own there (Figma has none). From seat picking it leaves, asking first if seats are held.
 */
export default function BookingHeaderBackButton(props: React.ComponentProps<typeof BackButton>): React.JSX.Element {
    const { currentStep, setCurrentStep } = useCartProvider();
    const router = useRouter();
    return (
        <BackButton
            {...props}
            onBack={() => {
                // Booked: nothing to step back to, the arrow leads to the start page.
                if (currentStep === '03_payment_complete') {
                    router.push('/');
                    return true;
                }
                const previous = PREVIOUS_STEP[currentStep];
                if (!previous) return false;
                setCurrentStep(previous);
                return true;
            }}
        />
    );
}
